import { Activity, EnhancedActivity } from '@app/core/interfaces/c5/enumerations';

export const RichPresenceStyles = {
  [Activity.AWAY]: { color: 'warning', icon: 'far fa-times' },
  [Activity.DND]: { color: 'danger', icon: 'far fa-minus-circle' },
  [Activity.HOME_OFFICE]: { color: 'success', icon: 'far fa-home' },
  [Activity.ILLNESS]: { color: 'danger', icon: 'far fa-clinic-medical' },
  [Activity.LUNCH]: { color: 'warning', icon: 'far fa-mug-hot' },
  [Activity.MEETING]: { color: 'danger', icon: 'far fa-calendar' },
  [EnhancedActivity.IN_A_CALL]: { color: 'danger', icon: 'far fa-phone' },
  [EnhancedActivity.PRESENTING]: { color: 'danger', icon: 'far fa-presentation' },
  [EnhancedActivity.IN_A_CONFERENCE_CALL]: { color: 'danger', icon: 'far fa-user-class' },
  [Activity.ONLINE]: { color: 'success', icon: 'far fa-check' },
  [Activity.OUT_OF_OFFICE]: { color: 'warning', icon: 'far fa-clock' },
  [Activity.VACATION]: { color: 'danger', icon: 'far fa-plane-departure' },
  [Activity.UNKNOWN]: { color: 'muted', icon: 'far fa-question-circle' },
  // yes, C5 also might return `undefined` for end-user's presence state (just after the activation of the rich presence service on enterprise)
  undefined: { color: 'muted', icon: 'far fa-question-circle' },
};
